// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Styles */
* {
  font-family: "Montserrat", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.page-container {
  padding: 0 56px;
  height: 100%;
  min-height: 100vh;
  position: relative;
  background-color: rgba(0, 0, 0, 0.5);
}
.scroll-top-btn {
  cursor: pointer;
  position: fixed;
  bottom: 32px;
  right: 55px;
  padding: 12px;
  border-radius: 12px;
  background-color: #FFFFFF;
}

@media only screen and (max-width: 800px) {
  .scroll-top-btn {
    border-radius: 50%;
    background-color: #FFFFFF4D;
    bottom: 20px;
    right: 7px;
    border: none;
  }
}

.video {
  width: 100%;
  position: fixed;
  left: 0;
  height: 100%;
  bottom: 0;
  top: 0;
  object-fit: cover;
  z-index: -1;
}

.general-container {
  display: flex;
  margin-top: 10px;
}

.centered-container {
  top: 50%;
}

.general-container .primary-container {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  margin-top: 50px;
}

.general-container .secondary-container {
  display: flex;
  /*margin-right: 15%;*/
}

.general-container .secondary-container .search-container {
  width: 100%;
  /*width: -webkit-fill-available;*/
}

.general-container .primary-container .let-us-know-cont {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 50px;
}

.general-container .primary-container .let-us-know-cont > div {
  width: 70%;
  font-size: 20px;
  font-weight: 400;
  color: #FFFFFF;
}

.thank-you-subtitle {
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
}

.general-container .primary-container .let-us-know-cont i {
  text-decoration: underline;
  cursor: pointer;
}

/* Submit Form */
.container {
  display: flex;
  justify-content: space-between;
}

.submit-form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 70vw;
  margin-top: 60px;
}

.fl-row {
  display: flex;
  align-items: center;
  width: 100%;
  margin: 8px -20px;
}

.fl-row-spacing {
  display: flex;
  margin: 16px 0;
}

.fl-row-spacing.sp-2 div:not(:last-child) {
  margin-right: 32px;
}

.fl-row .fl-col {
  padding: 0 20px;
}

.fl-row .fl-col.fw-6 {
  flex-basis: 50%;
  width: 50%;
}

.fl-row .fl-col.fw-gr {
  flex-grow: 1;
  width: 100%;
}

.related-search-container {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-top: 41px;
  min-width: 402px;
}

.related-search-container .section-option-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.related-search-container .related-search-title {
  font-size: 24px;
  color: #ffffff99;
  line-height: 43.88px;
  font-weight: 800;
  margin-bottom: 10px;
}

.related-search-container .section-option {
  display: flex;
  justify-content: center;
  width: fit-content;
  font-weight: 700;
  align-items: center;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  text-transform: uppercase;
  background-color: rgba(255, 255, 255, 0.3);
  margin-top: 30px;
  cursor: pointer;
  padding: 26px 50px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
}

@media only screen and (max-width: 1200px) {
  .page-container {
    margin-bottom: 45px;
    padding: 0 30px;
  }

  .related-search-container {
    align-items: flex-start;
  }

  .related-search-container .section-option-wrapper {
    align-items: flex-start;
  }

  .general-container .primary-container .let-us-know-cont > div {
    font-size: 16px;
  }

  .general-container .secondary-container .categories-button {
    display: none;
  }

  .general-container .secondary-container {
    flex-direction: column;
  }
}

@media only screen and (max-width: 768px) {
  .general-container {
    margin-top: 20px;
  }

  .fl-row {
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
  }

  .fl-row .fl-col {
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
  }

  .submit-form {
    max-width: 40vw;
  }
}

@media only screen and (max-width: 480px) {
  .general-container {
    flex-direction: column;
  }

  .submit-form .fl-row-spacing.sp-2 div:not(:last-child) {
    margin-right: 0;
    margin-bottom: 20px;
  }

  .submit-form .fl-row-spacing {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }

  .fl-row {
    align-items: center;
  }

  .submit-form .fl-row .fl-col.fw-6 {
    width: 100%;
  }

  .related-search-container {
    align-items: unset;
    margin-top: 30px;
    justify-content: center;
    min-width: unset;
  }

  .related-search-container .related-search-title {
    line-height: 28px;
  }

  .related-search-container .section-option-wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
  }

  .related-search-container .section-option {
    width: 100%;
    padding: 26px 0;
    margin-right: 0;
    margin-top: 20px;
  }

  .related-search-container .section-option.first {
    margin-top: 10px;
  }

  .submit-form {
    max-width: 100%;
    margin-top: 0;
  }

  .general-container .primary-container .let-us-know-cont {
    margin-top: 30px;
    margin-bottom: 10px;
  }
}

@media only screen and (max-width: 320px) {
  .page-container {
    margin-bottom: 70px;
    padding: 0 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,gDAAgD;EAChD,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,UAAU;IACV,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,OAAO;EACP,YAAY;EACZ,SAAS;EACT,MAAM;EACN,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":["/* General Styles */\n* {\n  font-family: \"Montserrat\", sans-serif !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.page-container {\n  padding: 0 56px;\n  height: 100%;\n  min-height: 100vh;\n  position: relative;\n  background-color: rgba(0, 0, 0, 0.5);\n}\n.scroll-top-btn {\n  cursor: pointer;\n  position: fixed;\n  bottom: 32px;\n  right: 55px;\n  padding: 12px;\n  border-radius: 12px;\n  background-color: #FFFFFF;\n}\n\n@media only screen and (max-width: 800px) {\n  .scroll-top-btn {\n    border-radius: 50%;\n    background-color: #FFFFFF4D;\n    bottom: 20px;\n    right: 7px;\n    border: none;\n  }\n}\n\n.video {\n  width: 100%;\n  position: fixed;\n  left: 0;\n  height: 100%;\n  bottom: 0;\n  top: 0;\n  object-fit: cover;\n  z-index: -1;\n}\n\n.general-container {\n  display: flex;\n  margin-top: 10px;\n}\n\n.centered-container {\n  top: 50%;\n}\n\n.general-container .primary-container {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  margin-top: 50px;\n}\n\n.general-container .secondary-container {\n  display: flex;\n  /*margin-right: 15%;*/\n}\n\n.general-container .secondary-container .search-container {\n  width: 100%;\n  /*width: -webkit-fill-available;*/\n}\n\n.general-container .primary-container .let-us-know-cont {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  margin-top: 40px;\n  margin-bottom: 50px;\n}\n\n.general-container .primary-container .let-us-know-cont > div {\n  width: 70%;\n  font-size: 20px;\n  font-weight: 400;\n  color: #FFFFFF;\n}\n\n.thank-you-subtitle {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 25px;\n  color: #ffffff;\n}\n\n.general-container .primary-container .let-us-know-cont i {\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n/* Submit Form */\n.container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.submit-form {\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n  max-width: 70vw;\n  margin-top: 60px;\n}\n\n.fl-row {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  margin: 8px -20px;\n}\n\n.fl-row-spacing {\n  display: flex;\n  margin: 16px 0;\n}\n\n.fl-row-spacing.sp-2 div:not(:last-child) {\n  margin-right: 32px;\n}\n\n.fl-row .fl-col {\n  padding: 0 20px;\n}\n\n.fl-row .fl-col.fw-6 {\n  flex-basis: 50%;\n  width: 50%;\n}\n\n.fl-row .fl-col.fw-gr {\n  flex-grow: 1;\n  width: 100%;\n}\n\n.related-search-container {\n  display: flex;\n  align-items: flex-end;\n  flex-direction: column;\n  margin-top: 41px;\n  min-width: 402px;\n}\n\n.related-search-container .section-option-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.related-search-container .related-search-title {\n  font-size: 24px;\n  color: #ffffff99;\n  line-height: 43.88px;\n  font-weight: 800;\n  margin-bottom: 10px;\n}\n\n.related-search-container .section-option {\n  display: flex;\n  justify-content: center;\n  width: fit-content;\n  font-weight: 700;\n  align-items: center;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n  border-radius: 10px;\n  text-transform: uppercase;\n  background-color: rgba(255, 255, 255, 0.3);\n  margin-top: 30px;\n  cursor: pointer;\n  padding: 26px 50px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n}\n\n@media only screen and (max-width: 1200px) {\n  .page-container {\n    margin-bottom: 45px;\n    padding: 0 30px;\n  }\n\n  .related-search-container {\n    align-items: flex-start;\n  }\n\n  .related-search-container .section-option-wrapper {\n    align-items: flex-start;\n  }\n\n  .general-container .primary-container .let-us-know-cont > div {\n    font-size: 16px;\n  }\n\n  .general-container .secondary-container .categories-button {\n    display: none;\n  }\n\n  .general-container .secondary-container {\n    flex-direction: column;\n  }\n}\n\n@media only screen and (max-width: 768px) {\n  .general-container {\n    margin-top: 20px;\n  }\n\n  .fl-row {\n    flex-direction: column;\n    align-items: flex-start;\n    margin: 0;\n  }\n\n  .fl-row .fl-col {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0;\n  }\n\n  .submit-form {\n    max-width: 40vw;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .general-container {\n    flex-direction: column;\n  }\n\n  .submit-form .fl-row-spacing.sp-2 div:not(:last-child) {\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n\n  .submit-form .fl-row-spacing {\n    width: 100%;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .fl-row {\n    align-items: center;\n  }\n\n  .submit-form .fl-row .fl-col.fw-6 {\n    width: 100%;\n  }\n\n  .related-search-container {\n    align-items: unset;\n    margin-top: 30px;\n    justify-content: center;\n    min-width: unset;\n  }\n\n  .related-search-container .related-search-title {\n    line-height: 28px;\n  }\n\n  .related-search-container .section-option-wrapper {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 20px;\n  }\n\n  .related-search-container .section-option {\n    width: 100%;\n    padding: 26px 0;\n    margin-right: 0;\n    margin-top: 20px;\n  }\n\n  .related-search-container .section-option.first {\n    margin-top: 10px;\n  }\n\n  .submit-form {\n    max-width: 100%;\n    margin-top: 0;\n  }\n\n  .general-container .primary-container .let-us-know-cont {\n    margin-top: 30px;\n    margin-bottom: 10px;\n  }\n}\n\n@media only screen and (max-width: 320px) {\n  .page-container {\n    margin-bottom: 70px;\n    padding: 0 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
